<template>
  <div>
    <h1>修改品牌</h1>
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
        label="品牌名称"
      >
        <a-input
          v-decorator="[
          'name',
           {initialValue: formData.name},
          {rules: [{ required: true, message: '必填项' }]}
        ]"
          placeholder="品牌名称"
        />
        <a-input
          v-decorator="[
          'id',
          {initialValue: formData.id},
        ]"
          hidden
        />
      </a-form-item>
      <a-form-item
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
        label="排序"
      >
        <a-input
          v-decorator="[
          'sortNo',
           {initialValue: formData.sortNo},
        ]"
          placeholder="排序"
        />
      </a-form-item>
      <a-form-item :label-col="formTailLayout.labelCol" :wrapper-col="formTailLayout.wrapperCol">
        <div>
          <a-button type="primary" html-type="submit">提交</a-button>&nbsp;
          <a-button @click="goBack">取消</a-button>
        </div>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8 }
};
const formTailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8, offset: 4 }
};
export default {
  name: "brandAdd",
  created() {},
  mounted() {
    this.getInfoById(this.$route.params.id);
  },
  data() {
    return {
      formData: {},
      formItemLayout,
      formTailLayout,
      form: this.$form.createForm(this)
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$http.post("/api/1.0/brand/save", values).then(res => {
            this.$http.ajaxResultDue(res, "/brand", null);
          });
        }
      });
    },
    getInfoById(id) {
      const url = "/api/1.0/brand/get/" + id;
      this.$http.get(url).then(res => {
        this.formData = res.data;
      });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
